import React from 'react';

class CalculatorResultCard extends React.Component {
  render() {
    const { isDreamSpace } = this.props;
    const className = isDreamSpace ? 'dreamspace' : '';

    return (
      <div className={`calculator-result-card ${className} ${this.props.light && 'light-bg'}`}>
        <p className={`calculator-result-card__caption ${className}`}>{this.props.caption}</p>
          <p className={`calculator-result-card__figure ${className}`}>
            <span className={`figure ${className}`}>{this.props.figure}</span>
            <span className={`figure-text ${className}`}>{this.props.figureText}</span>
          </p>
        <div className="calculator-result-card__additional-info">{this.props.additionalInfo}</div>
      </div>
    )
  }
}

export default CalculatorResultCard;
